module.exports = __webpack_public_path__ + "static/room2_2-ffb08c69c6bcd6f595135206e6e89fca.jpg";